import { enqueueSnackbar } from "notistack";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function useNavMessage() {
  const { state, pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (state?.message) {
      enqueueSnackbar({ variant: "error", message: state?.message });
      navigate(pathname, { state: null });
    }
  }, [state?.message, pathname, navigate]);
}
